import { styled } from '@volkswagen-onehub/components-core';
import { COLOR_TOKEN } from 'src/components/color-token';

const getGreyCard = props => {
	return props.greyCard ? 'tertiary' : 'primary';
};

export interface BoxCardProps {
	selected?: boolean;
	isCarousel: boolean;
	isHover?: boolean;
	isFirstDesktop?: boolean;
	greyCard?: boolean;
	iDBuzzExclusive?: boolean;
	isInverted?: boolean;
}

export const BoxCard = styled.div<BoxCardProps>`
	width: 100%;
	background-color: ${COLOR_TOKEN.main.content.primary};
	margin-top: ${props =>
		props.isCarousel || props.isFirstDesktop || props.iDBuzzExclusive
			? '0'
			: '20px'};
	padding: ${props => (props.isCarousel ? '12px' : '20px')};
	border: ${props =>
		props.selected && props.greyCard && !props.isCarousel
			? `2px solid ${COLOR_TOKEN.main.border.active}`
			: props.greyCard && !props.isCarousel
			? `1px solid ${COLOR_TOKEN.main.border.active}`
			: props.selected && !props.isCarousel
			? `2px solid ${COLOR_TOKEN.main.border.active}`
			: props.isCarousel
			? 'none'
			: `1px solid ${COLOR_TOKEN.main.border.default}`};
	:hover {
		border: ${props =>
			props.isCarousel
				? 'none'
				: props.selected && props.greyCard
				? `2px solid ${COLOR_TOKEN.main.border.active}`
				: props.greyCard
				? `1px solid ${COLOR_TOKEN.main.border.active}`
				: props.selected
				? `2px solid ${COLOR_TOKEN.main.border.active}`
				: `1px solid ${COLOR_TOKEN.main.border.default}`};
	}
	@media all and (min-width: 560px) {
		margin-top: ${props =>
			props.isCarousel || props.isFirstDesktop || props.iDBuzzExclusive
				? '0'
				: '24px'};
		padding: 20px;
	}
	@media screen and (min-width: 960px) {
		.main {
			border: ${props =>
				props.isCarousel
					? 'none'
					: props.selected
					? `2px solid ${COLOR_TOKEN.main.border.active}`
					: props.isHover
					? `1px solid ${COLOR_TOKEN.main.border.hover}`
					: `1px solid ${COLOR_TOKEN.main.border.default}`};
		}
		.inverted {
			border: ${props =>
				props.isCarousel
					? 'none'
					: props.selected
					? `2px solid ${COLOR_TOKEN.inverted.border.active}`
					: props.isHover
					? `1px solid ${COLOR_TOKEN.inverted.border.hover}`
					: `1px solid ${COLOR_TOKEN.inverted.border.default}`};
		}
	}
	@media all and (min-width: 1600px) {
		margin-top: ${props =>
			props.isCarousel || props.isFirstDesktop || props.iDBuzzExclusive
				? '0'
				: '28px'};
	}
`;

export const EllipsisTextWrapper = styled.p<{ greyCard?: boolean }>`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	margin-top: 0px;
	margin-bottom: 0px;
	color: ${props => COLOR_TOKEN.inverted.content[getGreyCard(props)]};
`;

export const GreyText = styled.span<{ greyCard?: boolean }>`
	color: ${props => COLOR_TOKEN.inverted.content[getGreyCard(props)]};
`;

export const SVGSize = styled.div<{ greyCard: boolean }>`
	padding-left: 16px;
	svg {
		height: 20px;
		width: auto;
		color: ${props => COLOR_TOKEN.inverted.content[getGreyCard(props)]};
	}
`;

export const CustomCTA = styled.button<{ greyCard?: boolean }>`
	height: 32px;
	width: max-content;
	padding: 8px 16px;
	border: none;
	cursor: pointer;
	border-radius: 22px;
	display: flex;
	align-items: center;
	background-color: ${props => COLOR_TOKEN.main.content[getGreyCard(props)]};
	color: ${COLOR_TOKEN.main.content.inverted};
	:hover {
		background-color: ${props =>
			COLOR_TOKEN.main.content[getGreyCard(props)]};
	}
`;
